
<template>
    <bcc-select
    v-model="selectVal"
    ref="bcc-select"
    @on-change="onChange"
    :placeholder="placeholder"
    :width="width">
    <div class="scroll_wrap" v-bccinfinite="[ispending, fetchNext]">
      <div @click.stop="() => {}" class="search-input_wrap" v-show="showSearch">
          <bcc-searchInput @on-search="val => $emit('on-search', val)" :autocomplete="autocomplete" :placeholder="inputPlaceHolder" v-model="keyWord"></bcc-searchInput>
      </div>
      <div class="search-list" >
        <div style="overflow: hidden;">
          <slot></slot>
        </div>
      </div>
    </div>
  </bcc-select>
</template>
<script>
import { Select as BccSelect } from '../select'
import BccSearchInput from '../searchInput'
export default {
  name: 'BccSearchSelect',
  componentName: 'BccSearchSelect',
  data () {
    return {
      keyWord: '',
      oldKeyW: '',
      selectVal: 'none'
    }
  },
  components: {
    BccSelect,
    BccSearchInput
  },
  watch: {
    keyWord (newVal) {
      this.$emit('changeKeyWord', newVal)
    },
    value (newVal) {
      this.selectVal = newVal
    },
    selectVal (newVal) {
      this.$emit('input', newVal)
    }
  },
  props: {
    value: {
      required: true
    },
    width: {
      type: [String, Number],
      default () {
        return '130'
      }
    },
    autocomplete: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default () {
        return true
      }
    },
    fetchNext: {
      type: Function,
      default () {
        return () => {}
      }
    },
    ispending: {
      type: Boolean,
      default () {
        return false
      }
    },
    inputPlaceHolder: {
      type: String,
      default () {
        return '请输入搜索内容'
      }
    },
    placeholder: {
      type: String,
      default () {
        return '请选择内容'
      }
    }
  },
  mounted () {
    this.selectVal = this.value
  },
  methods: {
    onChange (val) {
      this.$emit('onChange', val)
    }
  }
}
</script>
